import script from "./searchSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./searchSelect.vue?vue&type=script&setup=true&lang=ts"

import "./searchSelect.vue?vue&type=style&index=0&id=b4285a86&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4285a86"]])

export default __exports__